import TreeNode from "owa-tree-node/lib/components/TreeNode";
import { observer } from "owa-mobx-react";
import { loadMoreFoldersAction as Strings_loadMoreFoldersAction } from "owa-folders-constants/lib/strings/LoadMore.locstring.json";
import loc from "owa-localize";
import type { FunctionComponent } from "react";

export interface LoadMoreNodeProps {
    // Callback on click of the Load More button
    onLoadMoreClickedCallback: () => void;
}

const defaultExport: FunctionComponent<LoadMoreNodeProps> = observer(function LoadMoreFolderNode(props: LoadMoreNodeProps) {
    return (<TreeNode displayName={loc(Strings_loadMoreFoldersAction)} isCustomActionNode={true} isRootNode={false} key={"loadMore"} onClick={props.onLoadMoreClickedCallback}/>);
}, "LoadMoreFolderNode");
export default defaultExport;
